import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ChooseYourPath from "@/components/ChooseYourPath";
import KitValueStack from "@/components/KitValueStack";
import TemplatePreview from "@/components/TemplatePreview";
import SupportOptions from "@/components/SupportOptions";
import CTARow from "@/components/CTARow";
import Reviews from "@/components/Reviews";
import HowItWorks from "@/components/HowItWorks";
import CredibilityStats from "@/components/CredibilityStats";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import LeadMagnet from "@/components/LeadMagnet";
import Footer from "@/components/Footer";
import StickyCTABar from "@/components/StickyCTABar";

// Lazy load non-critical overlays to reduce initial bundle and improve TTI
const LeadMagnetPopup = lazy(() => import("@/components/LeadMagnetPopup"));
const CookieConsent = lazy(() => import("@/components/CookieConsent"));

const Index = () => {
  return (
    <>
      <Helmet>
        <title>MyCreditScrub - DIY Credit Dispute Kit | Fix Your Credit Score</title>
        <meta 
          name="description" 
          content="44% of credit reports contain errors. Learn how to dispute them yourself with our proven DIY Credit Dispute Kit. Step-by-step guide, professional dispute templates. Trusted by 10,000+ customers." 
        />
        <meta name="keywords" content="credit dispute, DIY credit fix, dispute letters, credit score improvement, credit dispute kit, remove collections, fix credit report errors" />
        <link rel="canonical" href="https://mycreditscrub.com" />
        
        {/* Open Graph */}
        <meta property="og:title" content="MyCreditScrub - DIY Credit Dispute Kit" />
        <meta property="og:description" content="44% of credit reports have errors. Fix yours with our proven DIY system — the same process experts charge $1,500+ for." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mycreditscrub.com" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MyCreditScrub - DIY Credit Dispute Kit" />
        <meta name="twitter:description" content="Stop guessing why your score won't budge. Our DIY kit shows you exactly how to dispute errors." />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main>
          {/* A: Hero with 4 buying paths */}
          <Hero />
          
          {/* B: Choose Your Path decision matrix */}
          <ChooseYourPath />
          
          {/* C: Kit Value Stack - featured bundle */}
          <KitValueStack />
          <CTARow />
          
          {/* D: Template Preview - popular templates */}
          <TemplatePreview />
          <CTARow />
          
          {/* E: Support Options - Packet Review + Done-For-You */}
          <SupportOptions />
          <CTARow />
          
          {/* F: Social Proof - reviews */}
          <Reviews />
          <CTARow />
          
          {/* G: How It Works - 3 steps */}
          <HowItWorks />
          
          {/* H: Credibility Stats */}
          <CredibilityStats />
          
          {/* I: FAQ with compliance */}
          <FAQ />
          <CTARow showPacketReview={false} />
          
          {/* J: Final CTA section */}
          <FinalCTA />
          
          {/* K: Lead Magnet - email capture */}
          <LeadMagnet />
        </main>
        <Footer />
        <StickyCTABar />
        <Suspense fallback={null}>
          <LeadMagnetPopup />
          <CookieConsent />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
